import { Button, Stack, Text, Textarea, TextInput, Title } from '@mantine/core';
import { useEffect, useState } from 'react';

import { useGetPageReportPrompt, useUpdatePageReportPrompt } from '../api/prompt';

import { ListLoader, ServerError } from '@/components';

export const AiReportPromptPage = () => {
  const promptQuery = useGetPageReportPrompt({});
  const updatePrompt = useUpdatePageReportPrompt();
  const prompt = promptQuery.data?.prompt;
  const [name, setName] = useState('');
  const [text, setText] = useState('');
  const [mergeText, setMergeText] = useState('');
  const [schemaText, setSchemaText] = useState('');
  const [schemaError, setSchemaError] = useState<string | null>(null);

  useEffect(() => {
    if (!prompt) return;
    setName(prompt.name);
    setText(prompt.prompt);
    setMergeText(prompt.mergePrompt);
    setSchemaText(JSON.stringify(prompt.schema, null, 2));
  }, [prompt]);

  if (promptQuery.isLoading) return <ListLoader />;
  if (promptQuery.isError || !prompt) {
    return (
      <ServerError onRetry={() => promptQuery.refetch()} isFetching={promptQuery.isFetching} />
    );
  }

  const save = () => {
    let schema: { name: string; schema: Record<string, unknown> };
    try {
      schema = JSON.parse(schemaText);
    } catch {
      setSchemaError('Схема должна быть валидным JSON');
      return;
    }
    setSchemaError(null);
    updatePrompt.mutate({ key: prompt.key, name, prompt: text, mergePrompt: mergeText, schema });
  };

  return (
    <Stack p="md" gap="md" maw={900}>
      <Title order={2}>Промт AI-отчётов</Title>
      <Text c="dimmed">
        Текст виден только здесь. Каждое сохранение создаёт новую версию, старые отчёты остаются на
        своей версии. Текущий текст разбирает ту же JSON-выгрузку сообщений, которую раньше отдавали
        в чат вручную.
      </Text>
      <Text>Текущая версия: {prompt.version}</Text>
      <TextInput
        label="Название типа"
        value={name}
        onChange={(event) => setName(event.currentTarget.value)}
      />
      <Textarea
        label="Промт страницы"
        description="Плейсхолдеры: {{language}}, {{languageName}}, {{pageName}}, {{period}}"
        minRows={12}
        autosize
        value={text}
        onChange={(event) => setText(event.currentTarget.value)}
      />
      <Textarea
        label="Промт сводки и склейки частей"
        minRows={8}
        autosize
        value={mergeText}
        onChange={(event) => setMergeText(event.currentTarget.value)}
      />
      <Textarea
        label="JSON-схема ответа"
        description="OpenAI strict: additionalProperties false, required совпадает с properties"
        minRows={12}
        autosize
        value={schemaText}
        error={schemaError}
        onChange={(event) => setSchemaText(event.currentTarget.value)}
        styles={{ input: { fontFamily: 'monospace' } }}
      />
      <Button loading={updatePrompt.isLoading} onClick={save}>
        Сохранить новую версию
      </Button>
    </Stack>
  );
};
